import { render, staticRenderFns } from "./PDFView.vue?vue&type=template&id=5ec08c4d&scoped=true&"
import script from "./PDFView.vue?vue&type=script&lang=js&"
export * from "./PDFView.vue?vue&type=script&lang=js&"
import style0 from "./PDFView.vue?vue&type=style&index=0&id=5ec08c4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec08c4d",
  null
  
)

export default component.exports